export default __webpack_public_path__ + "static/TungstenNarrow-Bold-991fd67d81b0a0c9767ba637c750530d.woff2";